import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTennis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z",
			stroke: "#198F58",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2C11.9495 5.3341 11.1309 7.8348 9.5442 9.5022C7.9574 11.1696 5.44265 12.0036 2 12.0042",
			stroke: "#198F58",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9841 12.5026C18.7278 12.2793 16.2397 12.9753 14.5197 14.5906C12.7997 16.206 11.9603 18.6758 12.0014 22",
			stroke: "#198F58",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgTennis;
